/** @file planeSigns: which side of each gizmo axis faces the viewer (where the move plane squares go). */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';

/**
 * `+1` when gizmo axis `k` points toward the viewer (its display-space direction against the view's `back`; display
 * space scales world z by `zScaleView`, as `projectOffset` does), else `-1`. Writes into `out` (no allocation).
 */
export function planeSigns(axes: readonly [Vec3, Vec3, Vec3], view: View, out: [number, number, number] = [1, 1, 1]): [number, number, number] {
  const b = view.basis.back;
  for (let k = 0; k < 3; k++) {
    const a = axes[k] ?? [0, 0, 0];
    out[k] = a[0] * b[0] + a[1] * b[1] + a[2] * view.zScaleView * b[2] >= 0 ? 1 : -1;
  }
  return out;
}
